<template>
  <div class="token-overview">
    <div class="token-overview-left">
      <div class="token-icon">
        <TransitSymbolIcon :icon="icon" :symbol="symbol" />
      </div>
      <div class="tsp-token-info">
        <div class="tsp-name text-ellipsis">{{ symbol || '~' }}</div>
        <div class="tsp-symbol text-ellipsis">{{ name || '~' }}</div>
      </div>
    </div>
    <div class="tsp-overview">
      <div class="tsp-overview-card tsp-overview-card--danger">
        <img class="tsp-overview-icon" src="../../assets/token-security/error-red.png" alt="" />
        <div class="tsp-overview-meta">
          <div class="tsp-overview-count">{{ risky === -1 ? '-' : risky }}</div>
          <div class="tsp-overview-label">
            {{ $t('tokenSecurityData.highRisk') }}
          </div>
        </div>
      </div>

      <div class="tsp-overview-card tsp-overview-card--warn">
        <img class="tsp-overview-icon" src="../../assets/token-security/warning.png" alt="" />
        <div class="tsp-overview-meta">
          <div class="tsp-overview-count">
            {{ attention === -1 ? '-' : attention }}
          </div>
          <div class="tsp-overview-label">
            {{ $t('tokenSecurityData.mediumRisk') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TransitSymbolIcon from "../TransitSymbolIcon.vue";
export default {
  props: {
    risky: {
      type: Number,
    },
    attention: {
      type: Number,
    },
    name: {
      type: String,
    },
    symbol: {
      type: String,
    },
    icon: {
      type: String,
    },
  },
  components: {
    TransitSymbolIcon,
  },
};
</script>

<style lang="scss" scoped>
.token-overview {
  margin-top: 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  padding: 16px;
  background: var(--bg-15);
  border: 1px solid var(--border-1);
  border-radius: 12px;

  .token-overview-left {
    flex: 1 1;
    min-width: 0;
    display: flex;
    align-items: center;
    gap: 12px;

    .token-icon {
      width: 40px;
      height: 40px;
      border-radius: 50%;
    }

    .tsp-token-info {
      flex: 1 1;
      min-width: 0;
      display: flex;
      flex-direction: column;
      gap: 2px;
      .tsp-name {
        font-size: 18px;
        font-weight: bold;
        color: var(--color-29);
      }
      .tsp-symbol {
        font-size: 14px;
        color: var(--color-27);
      }
    }
  }

  .tsp-overview {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;

    .tsp-overview-card {
      background: var(--bg-14);
      border-radius: 8px;
      display: flex;
      gap: 12px;
      align-items: center;
      padding: 8px 36px 8px 8px;

      .tsp-overview-icon {
        width: 40px;
        height: 40px;
      }

      .tsp-overview-count {
        font-size: 18px;
        font-weight: 500;
        color: #e55036;
      }

      .tsp-overview-label {
        font-size: 12px;
        color: var(--color-29);
        white-space: nowrap;
      }

      &--warn {
        .tsp-overview-count {
          color: #ff7114;
        }
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .token-overview {
    flex-direction: column;
    align-items: flex-start;
    background: none;
    border: none;
    padding: 0;
    gap: 12px;

    .token-overview-left {
      width: 100%;
      .token-icon {
        width: 44px;
        height: 44px;
      }

      .tsp-token-info {
        .tsp-name {
          font-size: 14px;
        }
        .tsp-symbol {
          font-size: 12px;
        }
      }
    }

    .tsp-overview {
      width: 100%;

      .tsp-overview-card {
        gap: 10px;
        padding: 10px;
        background: var(--bg-39);
        .tsp-overview-icon {
          width: 36px;
          height: 36px;
        }

        .tsp-overview-count {
          font-size: 16px;
        }
      }
    }
  }
}
</style>
